<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="600px"
  >
    <template v-slot:activator="{ on }">
      <v-btn 
        icon 
        v-on="on"
      >
        <v-icon color="primary">
          mdi-pencil
        </v-icon>
      </v-btn>
    </template>
    
    <material-card
      :offset="10"
      :full-width="true"
      color="hrissecondary"
      title="Deduction or Earnings"
      text="Update deduction or earning"
      class="mb-0"
      :loading="loading"
    >
      <form v-if="dialog && !loading">
        <v-container>
          <v-row>
            <v-col
              cols="12"
              class="pb-0"
            >
              <v-text-field
                v-model="localDoe.name"
                v-validate="'required'" 
                label="Name"
                :error-messages="errors.collect('name')"
                data-vv-name="name"    
                data-vv-as="name" 
                outlined
              />
            </v-col>

            <v-col
              cols="12"
              class="pb-8"
            >
              <tiptap-vuetify
                v-model="localDoe.description"
                class="full-width text-editor-toolbar-height pb-1"
                placeholder="Description"
                :extensions="extensions"
              />
            </v-col>

            <v-col
              cols="12"
              class="py-0"
            >
              <v-autocomplete
                v-model="localDoe.payroll_cycle_id" 
                v-validate="'required'"
                :error-messages="errors.collect('payroll_cycle_id')"    
                data-vv-name="payroll_cycle_id" 
                data-vv-as="doe category"
                label="Payroll Cycle"
                item-text="code"
                item-value="id"
                :items="payrollCycles"
                outlined
              >
                <template v-slot:item="data">
                  <v-list-item-content>
                    <span class="font-weight-bold">{{ data.item.code }}</span>
                    <span style="width:100px">{{ data.item.name }}</span>
                  </v-list-item-content>
                </template>
              </v-autocomplete>
            </v-col>

            <v-col
              cols="12"
              class="py-0"
            >
              <v-autocomplete
                v-model="localDoe.doe_category_id" 
                v-validate="'required'"
                :error-messages="errors.collect('doe_category_id')"    
                data-vv-name="doe_category_id" 
                data-vv-as="doe category"
                label="DOE Category"
                item-text="code"
                item-value="id"
                :items="doeCategories"
                outlined
              >
                <template v-slot:item="data">
                  <v-list-item-content>
                    <span class="font-weight-bold">{{ data.item.code }}</span>
                    <span style="width:100px">{{ data.item.name }}</span>
                  </v-list-item-content>
                </template>
              </v-autocomplete>
            </v-col>

            <v-col
              cols="12"
              class="py-0"
            >
              <v-autocomplete
                v-model="localDoe.cutoff_type_id" 
                v-validate="'required'"
                :error-messages="errors.collect('cutoff_type_id')"    
                data-vv-name="cutoff_type_id" 
                data-vv-as="cutoff type"
                label="Cutoff Types"
                item-text="code"
                item-value="id"
                :items="cutoffTypes"
                outlined
              >
                <template v-slot:item="data">
                  <v-list-item-content>
                    <span class="font-weight-bold">{{ data.item.code }}</span>
                    <span
                      style="width:100px"
                      v-html="data.item.description"
                    />
                  </v-list-item-content>
                </template>
              </v-autocomplete>
            </v-col>

            <v-col
              cols="12"
              class="py-0"
            >
              <v-autocomplete
                v-model="localDoe.tax_exemption_id" 
                label="Tax Exemption"
                item-text="name"
                item-value="id"
                :items="taxExemptions"
                outlined
                clearable
              />
            </v-col>

            <v-col
              cols="12"
              class="py-0"
            >
              <v-autocomplete
                v-model="localDoe.ea_class"
                v-validate="'required'"
                :error-messages="errors.collect('ea_class')"    
                data-vv-name="ea_class" 
                data-vv-as="ea class"
                label="EA class"
                outlined
                :items="eaItems"
                item-text="text"
                item-value="value"
              />
            </v-col>
        
            <v-col
              cols="12"
              class="py-0"
              lg="4"  
              xl="4"
              md="6"
              sm="6"
            >
              <span>Is Taxable? </span>
              <v-radio-group
                v-model="localDoe.is_taxable"
                class="mt-0"
                row
              >
                <v-radio
                  label="Yes"
                  :value="1"
                /> 
                <v-radio
                  label="No"
                  :value="0"
                />
              </v-radio-group>
            </v-col>

            <v-col
              cols="12"
              class="py-0"
              lg="4"  
              xl="4"
              md="6"
              sm="6"
            >
              <span> Is EPF? </span>
              <v-radio-group
                v-model="localDoe.is_epf"
                class="mt-0"
                row
              >
                <v-radio
                  label="Yes"
                  :value="1"
                /> 
                <v-radio
                  label="No"
                  :value="0"
                />
              </v-radio-group>
            </v-col>
           
            <v-col
              cols="12"
              class="py-0"
              lg="4"  
              xl="4"
              md="6"
              sm="6"
            >
              <span>Is EIS? </span>
              <v-radio-group
                v-model="localDoe.is_eis"
                class="mt-0"
                row
              >
                <v-radio
                  label="Yes"
                  :value="1"
                /> 
                <v-radio
                  label="No"
                  :value="0"
                />
              </v-radio-group>
            </v-col>

            <v-col
              cols="12"
              class="py-0"
              lg="4"  
              md="6"
              xl="4"
              sm="6"
            >
              <span> Is Socso? </span>
              <v-radio-group
                v-model="localDoe.is_socso"
                class="mt-0"
                row
              >
                <v-radio
                  label="Yes"
                  :value="1"
                /> 
                <v-radio
                  label="No"
                  :value="0"
                />
              </v-radio-group>
            </v-col>

            <v-col
              cols="12"
              class="py-0"
              lg="4"
              md="6"
              sm="6"
              xl="4"
            >
              <span>Is HRDF? </span>
              <v-radio-group
                v-model="localDoe.is_hrdf"
                class="mt-0"
                row
              >
                <v-radio
                  label="Yes"
                  :value="1"
                /> 
                <v-radio
                  label="No"
                  :value="0"
                />
              </v-radio-group>
            </v-col>

            <v-col
              cols="12"
              class="py-0"
              lg="4"  
              xl="4"
              md="6"
              sm="6"
            >
              <span>Is Negative? </span>
              <v-radio-group
                v-model="localDoe.is_negative"
                class="mt-0"
                row
              >
                <v-radio
                  label="Yes"
                  :value="1"
                /> 
                <v-radio
                  label="No"
                  :value="0"
                />
              </v-radio-group>
            </v-col>

            <v-col
              v-if="!localDoe.is_negative"
              cols="12"
              class="py-0"
              lg="4"  
              xl="4"
              md="6"
              sm="6"
            >
              <span> Is Additional Remuneration? </span>
              <v-radio-group
                v-model="localDoe.is_additional_remuneration"
                class="mt-0"
                row
              >
                <v-radio
                  label="Yes"
                  :value="1"
                /> 
                <v-radio
                  label="No"
                  :value="0"
                />
              </v-radio-group>
            </v-col>
          </v-row>
        </v-container>
      </form> 

      <v-card-actions v-if="dialog && !loading">
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          class="px-10"
          @click="dialog = false"
        >
          Cancel
        </v-btn>
        <v-btn
          :loading="progressing"
          color="hrissecondary"    
          class="white--text px-10"      
          @click="submitForm"
        >
          Update
        </v-btn>
      </v-card-actions> 
    </material-card>  
  </v-dialog>
</template>

<script>
  import { TiptapVuetify, Heading, Bold, Italic, Underline, BulletList, OrderedList, ListItem, Link, HardBreak } from 'tiptap-vuetify'

  export default {
    $_veeValidate: {
      validator: 'new', 
    },
    components: {
      TiptapVuetify,
    },
    props: {
      doe: {
        type: Object,
        default: null,
      },
    },
    data () {
      return {
        dialog: false,
        progressing: false,
        localDoe: null,
        loading: false,
        cutoffTypes: [],
        doeCategories: [],
        payrollCycles: [],
        taxExemptions: [],
        extensions: [
          Link,
          Underline,
          Italic,
          ListItem,
          BulletList,
          OrderedList,
          [Heading, {
            options: {
              levels: [1, 2, 3],
            },
          }],
          Bold,
          HardBreak,
        ],
        eaItems: [
          { value: 'gross_wages_leave_pay', text: 'gross_wages_leave_pay' },
          { value: 'allowance', text: 'allowance' },
          { value: 'fee', text: 'fee' },
          { value: 'commission', text: 'commission' },
          { value: 'bonus', text: 'bonus' },
          { value: 'tips_perquisites_awards', text: 'tips_perquisites_awards' },
          { value: 'overtime', text: 'overtime' },
          { value: 'tax_borne_by_employer', text: 'tax_borne_by_employer' },
          { value: 'esos', text: 'esos' },
          { value: 'arrears', text: 'arrears' },
          { value: 'pension', text: 'pension' },
          { value: 'annuities', text: 'annuities' },
          { value: 'levy', text: 'levy' },
          { value: 'zakat', text: 'zakat' },
          { value: 'compensation', text: 'compensation' },
          { value: 'refund', text: 'refund' },
          { value: 'gratuity', text: 'gratuity' },
          { value: 'cp38', text: 'cp38' },
          { value: 'none', text: 'None of the above (won\'t include the amount in EA)' },
        ],
        x: null,
        yearFilter: parseInt(this.$moment().format('YYYY')),
      }
    },
    watch: {
      dialog: function (value) {
        if (!value) return

        this.loading = true

        this.localDoe = { ...this.doe }

        Promise.all([
          this.$api.cutoffTypes().list('?filter[type]=monthly'),
          this.$api.doeCategories().list(),
          this.$api.taxExemptions().list({ year: this.yearFilter }),
          this.$api.hrisPayrollCycles().list(),
        ])
          .then(([cutoffType, doeCategory, taxExemptions, payrollCycles]) => {
            this.cutoffTypes = _.orderBy(cutoffType.data, ['code'], ['asc'])    
            this.doeCategories = _.orderBy(doeCategory.data, ['code'], ['asc'])    
            this.taxExemptions = _.orderBy(taxExemptions.data, ['code'], ['asc'])   
            this.payrollCycles = _.orderBy(payrollCycles.data, ['code'], ['asc'])   

            this.loading = false
          })
      },
    },
    methods: { 
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return

            this.setProgressing(true)

            this.$api.deductionOrEarnings().update(this.doe.id, this.prepareFormData())
              .then(response => {
                if (response.status === 200) {
                  this.$emit('updated')
                  this.$snack({ message: response.data.status })

                  this.setProgressing(false)
                  this.dialog = false
                }
              })
              .catch(() => {
                this.setProgressing(false)
              })
          })
      },
      setProgressing (status) {
        this.progressing = status
      },
      prepareFormData () {
        return {
          name: this.localDoe.name,
          description: this.localDoe.description,
          cutoff_type_id: this.localDoe.cutoff_type_id,
          doe_category_id: this.localDoe.doe_category_id,
          payroll_cycle_id: this.localDoe.payroll_cycle_id,
          is_prorated: this.localDoe.is_prorated,
          is_get_full_amount: this.localDoe.is_get_full_amount,
          is_epf: this.localDoe.is_epf,
          is_negative: this.localDoe.is_negative,
          is_eis: this.localDoe.is_eis,
          is_retirement_benefit: this.localDoe.is_retirement_benefit,
          is_gratuity: this.localDoe.is_gratuity,
          is_socso: this.localDoe.is_socso,
          is_hrdf: this.localDoe.is_hrdf,
          is_additional_remuneration: this.localDoe.is_negative ? 0 : this.localDoe.is_additional_remuneration,
          ea_class: this.localDoe.ea_class,
          tax_class: this.localDoe.tax_class,
          tax_exemption_id: this.localDoe.tax_exemption_id !== undefined ? this.localDoe.tax_exemption_id : null,
          is_taxable: this.localDoe.is_taxable,
        }
      },
    },
  }
</script>

<style scoped>
.text-editor-toolbar-height>>> .v-toolbar__content{
  height: unset !important;
  min-height: 42px;
}
.text-editor-toolbar-height>>>.v-sheet.v-sheet--tile.theme--light.v-toolbar.v-toolbar--dense.v-toolbar--flat.grey.lighten-4{
  min-height:unset !important;
}
.full-width{
  width: 100%;
}
</style>
